export const SEND_USER_FEEDBACK = 'USER_FEEDBACK/SEND_FEEDBACK';

export const sendUserFeedbackAction = (featureName, positive, data, relatedDataId) => ({
  type: SEND_USER_FEEDBACK,
  featureName,
  positive,
  data,
  relatedDataId
});
